// import React, { useEffect, useState } from "react";
// import ReactStars from "react-rating-stars-component";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/free-mode";
// import "swiper/css/pagination";
// import "../../App.css";
// import { FaStar } from "react-icons/fa";
// import { Autoplay, FreeMode, Pagination } from "swiper";
// import { apiConnector } from "../../Service/apiConnector";
// import { ratingsEndpoints } from "../../Service/apis";

// function ReviewSlider() {
//  const reviews = useSelector((state) => state.review.reviews);
// const dispatch = useDispatch();

//   const truncateWords = 15;

//   // useEffect(() => {
//   //   const fetchReviews = async () => {
//   //     try {
//   //       const { data } = await apiConnector("GET", ratingsEndpoints.REVIEWS_DETAILS_API);
//   //       if (data?.success) {
//   //         setReviews(data?.data);
//   //       }
//   //     } catch (error) {
//   //       console.error("Error fetching reviews: ", error);
//   //     }
//   //   };

//   //   fetchReviews();
//   // }, []);

//   useEffect(() => {
//   if (reviews.length === 0) {
//     console.log("📡 Fetching reviews from API");

//     const fetchReviews = async () => {
//       try {
//         const { data } = await apiConnector(
//           "GET",
//           ratingsEndpoints.REVIEWS_DETAILS_API
//         );

//         if (data?.success) {
//           dispatch(setReviews(data.data));
//         }
//       } catch (error) {
//         console.error("Error fetching reviews:", error);
//       }
//     };

//     fetchReviews();
//   } else {
//     console.log("✅ Using cached reviews from Redux");
//   }
// }, [reviews.length, dispatch]);


import React, { useEffect } from "react";
import ReactStars from "react-rating-stars-component";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "../../App.css";
import { FaStar } from "react-icons/fa";
import { Autoplay, FreeMode, Pagination } from "swiper";
import { useDispatch, useSelector } from "react-redux";

import { apiConnector } from "../../Service/apiConnector";
import { ratingsEndpoints } from "../../Service/apis";
import { setReviews } from "../../Slice/reviewSlice";

function ReviewSlider() {
  const dispatch = useDispatch();

  // ✅ SAFE REDUX SELECTOR
  const reviews = useSelector((state) => state.review.reviews) || [];

  const truncateWords = 15;

  // ✅ FETCH ONLY IF NOT IN REDUX
  useEffect(() => {
    if (reviews.length === 0) {
      // console.log("📡 Fetching reviews from API");

      const fetchReviews = async () => {
        try {
          const { data } = await apiConnector(
            "GET",
            ratingsEndpoints.REVIEWS_DETAILS_API
          );

          if (data?.success) {
            dispatch(setReviews(data.data));
          }
        } catch (error) {
          console.error("❌ Error fetching reviews:", error);
        }
      };

      fetchReviews();
    } else {
      // console.log("✅ Using cached reviews from Redux");
    }
  }, [reviews, dispatch]);

  // ✅ PREVENT SWIPER CRASH
  if (reviews.length === 0) {
    return null;
  }

  return (
    <div className="text-white">
      <div className="my-[50px] h-[184px] max-w-[100vw] lg:max-w-maxContent p-1">
        <Swiper
          slidesPerView={reviews.length < 4 ? reviews.length % 4 : 4}
          spaceBetween={14}
          loop={true}
          freeMode={true}
          autoplay={{
            delay: 1000,
            disableOnInteraction: false,
          }}
          modules={[FreeMode, Pagination, Autoplay]}
          className="w-full"
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index}>
              <div className="bg-richblack-800 p-4 text-richblack-25 rounded-lg">
                <div className="flex items-center gap-4">
                  <img
                    src={review?.user?.image ? review?.user?.image : `https://api.dicebear.com/5.x/initials/svg?seed=${review?.user?.firstName} ${review?.user?.lastName}`}
                    alt={`${review?.user?.firstName} ${review?.user?.lastName}`}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                  <div className="flex flex-col">
                      <h1 className="font-semibold text-richblack-5">{`${review?.user?.firstName} ${review?.user?.lastName}`}</h1>
                      <h2 className="text-[12px] font-medium text-richblack-500">
                        {review?.course?.courseName}
                      </h2>
                    </div>
                </div>
                <p className="font-medium text-richblack-25">
                    {review?.review.split(" ").length > truncateWords
                      ? `${review?.review
                          .split(" ")
                          .slice(0, truncateWords)
                          .join(" ")} ...`
                      : `${review?.review}`}
                  </p>
                <div className="flex items-center mt-3 gap-2">
                  <h3 className="font-semibold text-yellow-400">{review.rating.toFixed(1)}</h3>
                  <ReactStars
                    count={5}
                    value={review.rating}
                    size={20}
                    edit={false}
                    activeColor="#ffd700"
                    emptyIcon={<FaStar />}
                    fullIcon={<FaStar />}
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default ReviewSlider;